import { defineComponent as _defineComponent } from 'vue'
import ProductRegistrationService from '@/services/product-registration.service';
import ProductRegistrationActionService from './product-registration-action.service';
import SelfServiceModal from '@/ui/shared/modals/SelfServiceModal.vue';
import { useRegisteredProductActions } from './registered-product-actions.composable';
import ProductFromWebOrderViewObject = Vertica.LouisPoulsen.Application.ProductRegistration.Responses.ProductFromWebOrderViewObject;
import RegisteredProductViewObject = Vertica.LouisPoulsen.Application.ProductRegistration.Responses.DashboardPageRegisteredProductViewObject;
import NonRegisteredProduct from './NonRegisteredProduct.vue';
import RegisteredProduct from './RegisteredProduct.vue';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardPage',
  props: {
    registeredProductPageUrl: null,
    manuallyRegisterProductUrl: null
  },
  setup(__props: any) {



const nonRegisteredProducts = ref<ProductFromWebOrderViewObject[]>([]);
const registeredProducts = ref<RegisteredProductViewObject[]>([]);

const showActionModal = ref<boolean>(false);

onMounted(() => {
    ProductRegistrationService.getProducts().then((data) => {
        nonRegisteredProducts.value = data.nonRegisteredProductsFromWebOrder;
        registeredProducts.value = data.registeredProducts;
    });
    checkIfRedirectedByAction();
});

function checkIfRedirectedByAction() {
    const context = ProductRegistrationActionService.GetActionContext();
    if (context) {
        showActionModal.value = true;
        actionProductName.value = context.name;
        actionType.value = context.action;
        ProductRegistrationActionService.DeleteActionContext();
    }
}

function hideActionModal() {
    showActionModal.value = false;
}

const imageError = ref<{[imageUrl: number]: boolean}>({});

function imageLoadError(index) {
    const newInView = Object.assign({}, imageError.value);
    newInView[index] = true;
    imageError.value = newInView;
}

const { actionType, actionProductName, actionTitle, actionText } = useRegisteredProductActions();

return { __sfc: true,nonRegisteredProducts, registeredProducts, showActionModal, checkIfRedirectedByAction, hideActionModal, imageError, imageLoadError, actionType, actionProductName, actionTitle, actionText, SelfServiceModal, NonRegisteredProduct, RegisteredProduct }
}

})